<div class="mt-4">
  <div *ngFor="let document of documentName">
    <div
      *ngIf="
        document.type !== DocumentType.ATTSCO &&
        document.type !== DocumentType.AVIECHEANCE &&
        getFileByDocumentType(document.type)
      "
      class="flex justify-between items-center p-4 border-2 border-lightest font-app-regular text-darkest rounded mb-2">
      <span
        class="cursor-pointer"
        (click)="downloadDocument(document.type, DocumentActionType.OPEN)"
        >{{ document.name | translate }}
      </span>

      <button
        *ngIf="policyStatus !== policyStates.Na && policyStatus !== policyStates.Terminated"
        class="text-red"
        (click)="downloadDocument(document.type, DocumentActionType.DOWNLOAD)">
        <i class="pi pi-download"></i>
      </button>
    </div>

    <!--Attestation scolaire-->
    <div *ngIf="document.type === DocumentType.ATTSCO">
      <div
        *ngFor="let doc of getDocumentsByType(DocumentType.ATTSCO); let i = index"
        class="flex justify-between items-center p-4 border-2 border-lightest font-app-regular text-darkest rounded mb-2">
        <span
          class="cursor-pointer"
          (click)="downloadDocumentApi(doc.documentId, DocumentActionType.OPEN)"
          >{{ document.name | translate }} {{ i + 1 }}
        </span>

        <button
          *ngIf="policyStatus !== policyStates.Na && policyStatus !== policyStates.Terminated"
          class="text-red"
          (click)="downloadDocumentApi(doc.documentId, DocumentActionType.DOWNLOAD)">
          <i class="pi pi-download"></i>
        </button>
      </div>
    </div>

    <!--Avis decheance-->
    <div *ngIf="document.type === DocumentType.AVIECHEANCE">
      <div *ngFor="let doc of getDocumentsByType(DocumentType.AVIECHEANCE); let i = index">
        <div
          class="flex justify-between items-center p-4 border-2 border-lightest font-app-regular text-darkest rounded mb-2">
          <span
            class="cursor-pointer"
            (click)="downloadDocumentApi(doc.documentId, DocumentActionType.OPEN)"
            >{{ document.name | translate }} {{ i + 1 }}
          </span>

          <button
            *ngIf="policyStatus !== policyStates.Na && policyStatus !== policyStates.Terminated"
            class="text-red"
            (click)="downloadDocumentApi(doc.documentId, DocumentActionType.DOWNLOAD)">
            <i class="pi pi-download"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
